import React, { useState, useEffect, useRef } from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import Axios from '../../config/axios';
import { dateWithNoTimezone } from '../Helpers/DateFormat';
import { Fragment } from 'react';
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';
import { useForm, Controller } from "react-hook-form";
import { toast, confirm } from '@rickylandino/react-messages';
import { Select } from 'antd';
import ContentEditable from "react-contenteditable";
import NotesDialog from './NotesDialog';

export default function NoteDetailsSlider(props) {
    const [state, setState] = useState({
        showPane: false,
        dataLoaded: false,
        mode: 'Add',
        usersListData: [],
        sliderTitle: ''
    });

    const [tableControl, setTableControl] = useState({
        page: 1,
        sizePerPage: 10
    });

    const [notes, setNotes] = useState(props.notes);

    const { register, getValues, setValue, control, watch } = useForm();

    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    var isDirty = useRef(false);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (type === 'change') {
                isDirty.current = true;
            }
        });

        LoadFormData();

        return () => subscription.unsubscribe();

    }, [props]);

    function LoadFormData() {
        //title = { state.mode === 'Add' ? 'Add New Note' : 'Edit Note' }

        var mySliderTitle = '';
        if (props.mode === 'Add') {
            mySliderTitle = 'Add Note';
        }
        else {
            if (props.notesDialogDisplayMode === 'Editable') {
                mySliderTitle = 'Edit Note';
            }
            else {
                mySliderTitle = 'View Note';
            }
        }

        Axios.post(`/api/GetAllUsers`, {
            params: {

            }
        }).then(response => {
            let usersList = response.data;

            if (props.selectedItemId !== null) {
                let notes = props.notes;
                const selectedIdx = notes.findIndex(n => n.itemId === props.selectedItemId);

                setValue('formFields', notes[selectedIdx]);
            }
            else {
                var note_date = new Date();
                setValue('formFields.note_date', note_date);
                setValue('formFields.note', '');
                setValue('formFields.salesperson', userInfo.userId);
            }

            setState({
                ...state,
                showPane: props.showPane,
                mode: props.mode,
                usersListData: usersList,
                dataLoaded: true,
                sliderTitle: mySliderTitle
            });

        }).catch(error => {
            console.log(error);
        });
    }

    function isHTML(input) {
        return /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(input);
    }

    //function isHTML(str) {
    //    var doc = new DOMParser().parseFromString(str, "text/html");
    //    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
    //}

    function closeSlider() {
        if (isDirty.current) {
            confirm({
                title: "You are about to close this note and lose any changes you've made.",
                content: "Are you sure you would like continue?",
                buttons: ["Yes", "No"],
            }, (buttonPressed) => {
                if (buttonPressed === 'Yes') {
                    hidePane();

                    return 0;
                } else {
                    return 0;
                }
            });
        } else {
            hidePane();
        }
    }

    function hidePane() {
        //now update the parent list
        //props.reloadNotesFromDB();

        //var localNotesList = newNotesList || [...notes];

        //if (props.mode === 'Edit') {
        //    const selectedIdx = localNotesList.findIndex(n => n.itemId === props.selectedItemId);
        //    localNotesList[selectedIdx] = getValues().formFields;

        //    //for graceful, animated close
        //    setTimeout(() => props.updateTableDisplay(localNotesList, selectedIdx), 1000);
        //}
        //else {
        //    setTimeout(() => props.reloadNotesFromDB(), 1000);
        //}

        setState({
            ...state,
            showPane: false
        });
    }

    function onUserChange(value) {
        setValue('formFields.salesperson', value)
        setState({ ...state });
    }

    function handleSave() {
        if (props.selectedItemId !== null) {
            UpdateCustomerNote();
        }
        else {
            InsertCustomerNote();
        }
    }

    function InsertCustomerNote() {
        let postdata = {};
        postdata.CustId = props.selectedCustomerId;
        postdata.note = getValues().formFields?.note;
        postdata.note_date = getValues().formFields?.note_date;
        postdata.division = userInfo.jobShopDivision;
        postdata.salesperson = userInfo.userId;
        postdata.pinned = getValues().formFields?.pinned;

        Axios.post('/api/InsertCustomerNote', postdata
        ).then(async response => {
            hidePane();
            toast.success('Note successfully added');

        }).catch(error => {
            console.log(error);
        });
    }

    function UpdateCustomerNote() {
        let postdata = {};

        postdata.ItemId = props.selectedItemId;
        postdata.note = getValues().formFields?.note;
        postdata.note_date = getValues().formFields?.note_date;
        postdata.salesperson = getValues().formFields?.salesperson;
        postdata.pinned = getValues().formFields?.pinned;

        Axios.post('/api/UpdateCustomerNote', postdata
        ).then(async response => {
            hidePane();
            toast.success('Note changes successfully saved');

        }).catch(error => {
            console.log(error);
        });
    }

    function handlePinnedChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        /*        const name = target.name;*/

        Axios.get(`/api/CheckForPinnedNote`, {
            params: {
                company_id: props.selectedCustomerId,
                itemId: props.selectedItemId,
            }
        }).then(response => {
            if (response.data === true) {
                if (userInfo.jobShopDivision === 'JSS') {
                    toast.error('Another note is already pinned for this exhibitor - only 1 is allowed');
                }
                else {
                    toast.error('Another note is already pinned for this advertiser - only 1 is allowed');
                }
                return;
            }
            else {
                setValue('formFields.pinned', value);

                setState({
                    ...state,
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    function handleNoteChange(e) {
        let target = e.target;
        let name = target.name;
        let value = target.value;

        setValue('formFields.note', value);

        setState({
            ...state,
        });
    }

    return (
        <SlidingPane
            className='some-custom-class w-65'
            overlayClassName='showCard'
            isOpen={state.showPane}
            title={state.sliderTitle}
            onRequestClose={closeSlider}
            width={props.noteQueue.length > 0 ? '85%' : '40%'}
            closeIcon={<i className="fas fa-chevron-right float-left"></i>}
        >
            <div style={{ height: 'calc(100% - 65px)'}}>
                <div className="h-100">
                    {state.dataLoaded &&
                        <NotesDialog noteQueue={props.noteQueue} selectedCustomerId={props.selectedCustomerId} hidePane={hidePane} notesDialogDisplayMode={props.notesDialogDisplayMode} />
                    }
                </div>
            </div>
        </SlidingPane>
    );
}